/** The information architecture (design 11 §2): the sections, in the navigation's order. */
import {
  Activity, AudioLines, BookOpen, Code2, Cpu, FileCode, Home, Megaphone, Network, Phone, PhoneCall, Settings, ShieldCheck, Bot,
  Handshake, Headset, LifeBuoy, MessagesSquare, UserCheck,
  type LucideIcon,
} from "lucide-react";
import type { MessageId } from "../i18n";

export interface Section {
  readonly path: string;
  label: MessageId;
  icon: LucideIcon;
  /** Not built yet: the release it is planned for. */
  release?: string;
}

/** A section with its path kept literal, so the router types every route (and every link to it). */
const section = <P extends string>(s: Section & { path: P }): Section & { path: P } => s;

export const SECTIONS = [
  section({ path: "/", label: "nav.home", icon: Home }),
  section({ path: "/chat", label: "nav.chat", icon: MessagesSquare }),
  section({ path: "/agents", label: "nav.agents", icon: Bot }),
  section({ path: "/scripts", label: "nav.scripts", icon: FileCode }),
  section({ path: "/knowledge", label: "nav.knowledge", icon: BookOpen }),
  section({ path: "/clips", label: "nav.clips", icon: AudioLines }),
  section({ path: "/models", label: "nav.models", icon: Cpu }),
  section({ path: "/calls", label: "nav.calls", icon: PhoneCall }),
  section({ path: "/handoffs", label: "nav.handoffs", icon: Handshake }),
  section({ path: "/assist", label: "nav.assist", icon: LifeBuoy }),
  section({ path: "/campaigns", label: "nav.campaigns", icon: Megaphone }),
  section({ path: "/numbers", label: "nav.numbers", icon: Phone }),
  section({ path: "/trunks", label: "nav.trunks", icon: Network }),
  section({ path: "/sip-users", label: "nav.sipUsers", icon: Headset }),
  section({ path: "/operators", label: "nav.operators", icon: UserCheck }),
  section({ path: "/compliance", label: "nav.compliance", icon: ShieldCheck }),
  section({ path: "/analytics", label: "nav.analytics", icon: Activity }),
  section({ path: "/developers", label: "nav.developers", icon: Code2 }),
  section({ path: "/settings", label: "nav.settings", icon: Settings }),
];
